interface IAuthState {
  isLoading: boolean;
  email: string | null;
  password: string | null;
  accessToken: string | null;
  registerToken: string | null;
  awsAccessToken: string | null;
  refreshToken: string | null;
  isOtpSetup: boolean;
  isMfaSetup: boolean;
  isProfileSetup: boolean;
  sendingVerify: boolean;
  isInvitedRegistration: boolean;
  cognitoSession: string | null;
  cognitoMfaAccessToken: string | null;
  federatedAccessToken: string | null;
  authType: 'email' | 'google' | 'microsoft';
}

export default (): IAuthState => ({
  isLoading: false,
  email: '',
  password: '',
  accessToken: '',
  registerToken: '',
  awsAccessToken: '',
  refreshToken: '',
  isOtpSetup: false,
  isMfaSetup: false,
  isProfileSetup: false,
  sendingVerify: false,
  isInvitedRegistration: false,
  cognitoSession: null,
  cognitoMfaAccessToken: null,
  federatedAccessToken: null,
  authType: 'email',
});
